module.exports = __webpack_public_path__ + "4fb6532d58668ef5f07105fdc3ee6723.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LB.svg
// module id = vRVh
// module chunks = 0